import React from 'react';
import {
  DatePickerFixed,
  DatePickerLast,
  DatePickerLastFull,
  DatePickerSince,
  DatePickerStartOf,
} from './DatePickerSelectors';
import { UnreachableCaseError } from 'ts-essentials';
import { IDatePickerFieldsFragment } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  datePicker: IDatePickerFieldsFragment;
  onChange: (newDatePicker: IDatePickerFieldsFragment) => void;
}

const DatePickerTypeSelector = ({ datePicker, onChange }: IProps) => {
  const type = datePicker.__typename;
  if (type === 'DatePickerLast') {
    return <DatePickerLast datePicker={datePicker} onChange={onChange} />;
  } else if (type === 'DatePickerSince') {
    return <DatePickerSince datePicker={datePicker} onChange={onChange} />;
  } else if (type === 'DatePickerFixed') {
    return <DatePickerFixed datePicker={datePicker} onChange={onChange} />;
  } else if (type === 'DatePickerLastFull') {
    return <DatePickerLastFull datePicker={datePicker} onChange={onChange} />;
  } else if (type === 'DatePickerStartOf') {
    return <DatePickerStartOf datePicker={datePicker} onChange={onChange} />;
  } else {
    throw new UnreachableCaseError(type);
  }
};

export default DatePickerTypeSelector;
